var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotstarted(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 24,
    fill: "#F4F7FA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.8333 16.9167V19.1667C24.8333 20.5668 24.8333 21.2669 25.1058 21.8016C25.3455 22.272 25.728 22.6545 26.1984 22.8942C26.7331 23.1667 27.4332 23.1667 28.8333 23.1667H31.0833M31.5 24.8235V27.5C31.5 28.9001 31.5 29.6002 31.2275 30.135C30.9878 30.6054 30.6054 30.9878 30.135 31.2275C29.6002 31.5 28.9001 31.5 27.5 31.5H20.5C19.0999 31.5 18.3998 31.5 17.865 31.2275C17.3946 30.9878 17.0122 30.6054 16.7725 30.135C16.5 29.6002 16.5 28.9001 16.5 27.5V20.5C16.5 19.0999 16.5 18.3998 16.7725 17.865C17.0122 17.3946 17.3946 17.0122 17.865 16.7725C18.3998 16.5 19.0999 16.5 20.5 16.5H23.1765C23.788 16.5 24.0937 16.5 24.3814 16.5691C24.6365 16.6303 24.8804 16.7313 25.104 16.8684C25.3563 17.023 25.5725 17.2392 26.0049 17.6716L30.3284 21.9951C30.7608 22.4275 30.977 22.6437 31.1316 22.896C31.2687 23.1196 31.3697 23.3635 31.4309 23.6186C31.5 23.9063 31.5 24.212 31.5 24.8235Z",
    stroke: "#334155",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotstarted);
export default __webpack_public_path__ + "static/media/notstarted.e98911942d576665969963ce17ec34d9.svg";
export { ForwardRef as ReactComponent };